"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("../../../");
require("./Item.scss");
const Item = _ref => {
  let {
    className,
    statusData
  } = _ref;
  const {
    status,
    title
  } = statusData;
  const rootClassName = (0, _classnames.default)('cds-StatusBarFull-Item', {
    'cds-StatusBarFull-Item--Done': status === _.STATUSBAR_STATUS.done,
    'cds-StatusBarFull-Item--InProgress': status === _.STATUSBAR_STATUS.inProgress
  }, className);
  return /*#__PURE__*/_react.default.createElement("li", {
    className: rootClassName
  }, status ? /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-StatusBarFull-ItemIcon",
    name: status === _.STATUSBAR_STATUS.done ? _Icon.ICON_NAME.progressDone : _Icon.ICON_NAME.progressOngoing,
    size: _Icon.ICON_SIZE.small
  }) : /*#__PURE__*/_react.default.createElement("span", {
    className: "cds-StatusBarFull-ItemCircle"
  }), title);
};
exports.Item = Item;
//# sourceMappingURL=Item.js.map